import { Component, OnInit, forwardRef, ViewChild, ElementRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormGroup, FormBuilder, ControlValueAccessor } from '@angular/forms';
import { ReferringPhysicianInstituteFilter } from '../../../model/referring-physician-institute-filter';
import { Observable } from 'rxjs';
import { ReferringPhysicianInstituteService } from '../../../services/referring-physician-institute.service';
import { filter, debounceTime, switchMap, tap, finalize } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { ValidateAutoCompleteSelect } from 'src/app/validators/autocomplete-select.validator';
import { ReferringPhysicianInstituteDialogComponent } from '../../dialogs/referring-physician-institute-dialog/referring-physician-institute-dialog.component';

export const REFERRING_PHYSICIAN_INSTITUTE_AUTOCOMPLETE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => ReferringPhysicianInstituteComponent),
  multi: true,
};

@Component({
  selector: 'app-referring-physician-institute',
  templateUrl: './referring-physician-institute.component.html',
  styleUrls: ['./referring-physician-institute.component.css'],
  providers: [REFERRING_PHYSICIAN_INSTITUTE_AUTOCOMPLETE_VALUE_ACCESSOR],
})
export class ReferringPhysicianInstituteComponent implements OnInit, ControlValueAccessor {

  onChange;
  inputText: string;
  filteredReferringPhysicianInstituteFilter: Observable<ReferringPhysicianInstituteFilter[]>;
  form: FormGroup;
  referringPhysiciansInstituteFilter: ReferringPhysicianInstituteFilter[] = [];
  selecting: boolean;
  loading: boolean;
  @Input() readOnly: boolean;
  @ViewChild('referringPhysicianInstituteCtrl', {static: false}) referringPhysicianInstituteCtrl: ElementRef;


  constructor(private formBuilder: FormBuilder,
              private dialog: MatDialog,
              private referringPhysicianInstituteService: ReferringPhysicianInstituteService) {

    this.form = this.formBuilder.group({
      ReferringPhysicianInsituteCtrl: [null]
    });
  }

  get f() { return this.form.controls; }

  get isSelected() {
    return this.form.controls.ReferringPhysicianInsituteCtrl.value
    && typeof this.form.controls.ReferringPhysicianInsituteCtrl.value !== 'string';
  }

  displayFn(item?: ReferringPhysicianInstituteFilter): string | undefined {
      return item ? item.Name : undefined;
  }

  ngOnInit() {
    this.f.ReferringPhysicianInsituteCtrl.valueChanges.pipe(
      filter(value => {
        if (value != null && value !== '' && typeof value === 'string') {
            return true;
        } else {
          if (value == null || value === '') {
            this.referringPhysiciansInstituteFilter = [];
          }
          return false;
        }
      }),
      debounceTime(400),
      tap(() => this.loading = true),
      switchMap(value => this.referringPhysicianInstituteService.getReferringPhysicianInstituteFilters(value)
        .pipe(finalize(() => this.loading = false), ))
    ).subscribe(values => this.referringPhysiciansInstituteFilter = values);
  }

  referringPhysicianFilterSelected(referringPhysicianInstituteFilter: ReferringPhysicianInstituteFilter) {
    this.selecting = true;
    this.form.patchValue({ ReferringPhysicianInsituteCtrl: referringPhysicianInstituteFilter });
    this.onChange(referringPhysicianInstituteFilter);
  }

  edit(): void {
    if (!ValidateAutoCompleteSelect(this.form.controls.ReferringPhysicianInsituteCtrl)) {
      const dialogRef = this.dialog.open(ReferringPhysicianInstituteDialogComponent, {
        width: '90%',
        data: {
          Id: this.form.controls.ReferringPhysicianInsituteCtrl.value.Id,
          Name: this.form.controls.ReferringPhysicianInsituteCtrl.value.Name
        }
      });

      dialogRef.afterClosed().subscribe(async (info: any) => {
        if (info) {
          this.referringPhysiciansInstituteFilter = [];
          this.referringPhysicianFilterSelected({
            Id: info.Id,
            Name: info.Name
          });
        }
      });
    }
  }

  create(): void {
    const dialogRef = this.dialog.open(ReferringPhysicianInstituteDialogComponent, {
      width: '90%',
      data: {
        Name: this.inputText
      }
    });

    dialogRef.afterClosed().subscribe(async (info: any) => {
      if (info) {
        this.referringPhysiciansInstituteFilter = [];
        this.referringPhysicianFilterSelected({
          Id: info.Id,
          Name: info.Name
        });
      }
    });
  }

  textChanged(text) {
    this.inputText = text;
  }

  onReferringPhysicianInstituteFilterChange() {
    this.onChange(null);
  }

  writeValue(obj: any): void {
    this.form.patchValue({ ReferringPhysicianInsituteCtrl: obj });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {

  }

  setFocus(): void {
    this.referringPhysicianInstituteCtrl.nativeElement.focus();
  }
}
